import nightModeReducer from '@app/store/slices/nightModeSlice';
import themeReducer from '@app/store/slices/themeSlice';
import pwaReducer from '@app/store/slices/pwaSlice';
import { user as userReducer } from '@app/store/slices/userSlice';
import { token as tokenReducer } from '@app/store/slices/token';
import { config as configReducer } from '@app/store/slices/config';
import { forgotPassword as forgotPasswordReducer } from '@app/store/slices/forgotPassword';
import { locale as localeReducer } from '@app/store/slices/locale';
import { waterBodies as waterBodiesReducer } from '@app/store/slices/waterbodies';
import { breedingJournal as breedingJournalReducer } from '@app/store/slices/breedingJournal';
import { inventory as inventoryReducer } from '@app/store/slices/inventory';
import { fishtypes as fishtypesReducer } from '@app/store/slices/fishtypes';
import { homeFilters as homeFiltersReducer } from '@app/store/slices/homeFilters';
import { inspectionsFilters as inspectionsFiltersReducer } from '@app/store/slices/inspectionsFilters';
import { breedingJournalFilters as breedingJournalFiltersReducer } from '@app/store/slices/breedingJournalFilters';
import { observationsFilters as observationsFiltersReducer } from '@app/store/slices/observationsFilters';
import { licensesFilters as licensesFiltersReducer } from '@app/store/slices/licensesFilters';
import { licensesReturnFilters as licensesReturnFiltersReducer } from '@app/store/slices/licensesReturnFilters';
import { inventoryFilters as inventoryFiltersReducer } from '@app/store/slices/inventoryFilters';
import { fishTypesFilters as fishTypesFiltersReducer } from '@app/store/slices/fishTypesFilters';
import { waterBodiesFilters as waterBodiesFiltersReducer } from '@app/store/slices/waterBodiesFilters';
import { sessionsFilters as sessionsFiltersReducer } from '@app/store/slices/sessionsFilters';
import { catchesFilters as catchesFiltersReducer } from './catchesFilters';
import { fishersFilters as fishersFiltersReducer } from './fishersFilters';
import { waterBodyRegulationsFilters as waterBodyRegulationsFiltersReducer } from '@app/store/slices/waterbodyRegulationsFilters';
import { stockingPlanFilters as stockingPlanFiltersReducer } from './stockingPlanFilters';
import { stockingJournalFilters as stockingJournalFiltersReducer } from './stockingJournalFilters';
import adminUsersFiltersReducer from './adminUsersFilters';
import { licenseTypesFilters as licenseTypesFiltersReducer } from './licenseTypesFilters';
import { killsFilters as killsFiltersReducer } from '@app/store/slices/killsFilters';
import { huntersFilters as huntersFiltersReducer } from './huntersFilters';
import { inboxMessagesFilters as inboxMessagesFiltersReducer } from './inboxMessagesFilters';
import { huntingLicensesFilters as huntingLicensesFiltersReducer } from './huntingLicensesFilters';
import { fishingFeesFilters as fishingFeesFiltersReducer } from '@app/store/slices/fishingFeesFilters';
import { huntingFeesFilters as huntingFeesFiltersReducer } from '@app/store/slices/huntingFeesFilters';
import { professionalFisherFilters as professionalFisherFiltersReducer } from '@app/store/slices/professionalFisherFilters';
import { allProfessionalFishersFilters as allProfessionalFishersFiltersReducer } from '@app/store/slices/allProfessionalFishersFilters';

export default {
  breedingJournal: breedingJournalReducer,
  inventory: inventoryReducer,
  user: userReducer,
  nightMode: nightModeReducer,
  theme: themeReducer,
  pwa: pwaReducer,
  token: tokenReducer,
  config: configReducer,
  forgotPassword: forgotPasswordReducer,
  locale: localeReducer,
  waterBodies: waterBodiesReducer,
  fishtypes: fishtypesReducer,
  homeFilters: homeFiltersReducer,
  inspectionsFilters: inspectionsFiltersReducer,
  catchesFilters: catchesFiltersReducer,
  breedingJournalFilters: breedingJournalFiltersReducer,
  inventoryFilters: inventoryFiltersReducer,
  observationsFilters: observationsFiltersReducer,
  fishersFilters: fishersFiltersReducer,
  licensesFilters: licensesFiltersReducer,
  licensesReturnFilters: licensesReturnFiltersReducer,
  licenseTypesFilters: licenseTypesFiltersReducer,
  fishTypesFilters: fishTypesFiltersReducer,
  waterBodiesFilters: waterBodiesFiltersReducer,
  waterBodyRegulationsFilters: waterBodyRegulationsFiltersReducer,
  stockingPlanFilters: stockingPlanFiltersReducer,
  stockingJournalFilters: stockingJournalFiltersReducer,
  sessionsFilters: sessionsFiltersReducer,
  adminUsersFilters: adminUsersFiltersReducer,
  killsFilters: killsFiltersReducer,
  huntersFilters: huntersFiltersReducer,
  inboxMessagesFilters: inboxMessagesFiltersReducer,
  huntingLicensesFilters: huntingLicensesFiltersReducer,
  fishingFeesFilters: fishingFeesFiltersReducer,
  huntingFeesFilters: huntingFeesFiltersReducer,
  professionalFisherFilters: professionalFisherFiltersReducer,
  allProfessionalFishersFilters: allProfessionalFishersFiltersReducer,
};
